import React, { useEffect, useState } from "react";
import axios from "axios";
import { FavoriteJob, Job } from "@bindeleddet/core/types";
import { Col, List, Empty } from "antd";
import SingleJobPostingBox from "containers/JobPostings/SingleJobPostingBox/SingleJobPostingBox";
import { useHistory } from "react-router-dom";
import MyProfileToolCard from "../MyProfileToolCard/MyProfileToolCard";

const MyFavorites = () => {
  const [favoriteJobs, setFavoriteJobs] = useState<Job[]>([]);
  // The raw favorite entries (as opposed to the full Job objects above) are what
  // SingleJobPostingBox needs to know which jobs are favorited and to toggle them.
  const [favoriteJobEntries, setFavoriteJobEntries] = useState<FavoriteJob[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchFavorites = async () => {
      setLoading(true);
      try {
        const favoriteJobsResponse = await axios.get<FavoriteJob[]>("/jobs/favorites/");
        setFavoriteJobEntries(favoriteJobsResponse.data);
        const jobIds = favoriteJobsResponse.data.map(job => job.job);

        if (jobIds.length > 0) {
          const allJobsResponse = await axios.get<Job[]>("/jobs/");
          const favoriteJobsData = allJobsResponse.data.filter(job => jobIds.includes(job.id));
          setFavoriteJobs(favoriteJobsData);
        } else {
          setFavoriteJobs([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);

  const favoriteJobBoxes = favoriteJobs.map(job => {
    return (
      <Col key={job.id} style={{ marginBottom: "1em", padding: 0 }}>
        <SingleJobPostingBox
          job={job}
          favoriteJobs={favoriteJobEntries}
          favoritesLoading={loading}
          onFavoriteJobsChange={setFavoriteJobEntries}
        />
      </Col>
    );
  });

  const history = useHistory();

  return (
    <MyProfileToolCard title="Mine favoritter" onBack={() => history.push("/student-profile")}>
      <List
        loading={loading}
        itemLayout="vertical"
        pagination={false}
        locale={{
          emptyText: !loading && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Du har ikke lagt til noen favoritter" />
          ),
        }}
        style={{ padding: 0, margin: 0 }}
        dataSource={favoriteJobBoxes}
        renderItem={item => item}
      />
    </MyProfileToolCard>
  );
};

export default MyFavorites;
